import axios from 'axios';

const tenantV2Query = `
query TenantV2Query($id: ID!) {
  node(id: $id) {
    ... on Tenant {
      defaultContent {
         id 
      }
      domain { 
        id
        name
        legacyAcId
      }
      enabled
      id
      lid
      name
      adminEmails
      intacctId
      customerName
      timezone
      notificationEmails
      legacyAcId
      usageType
      supportNotes
      defaultShowContentProgress
      defaultHoursOfOperation
      addons {
        id
        lid
        gidV3
      }
      edition {
        id
        gidV3
        lid
      }
      organization { 
        legacyAcId
        name
        domains {
          edges {
            node {
              id
              name
            }
          }
        }
      }
      __typename
    }
  }
}
`;

const tenantV2QueryNonAdmin = `
query TenantV2QueryNonAdmin($id: ID!) {
  node(id: $id) {
    ... on Tenant {
      defaultContent {
         id 
      }
      enabled
      id
      lid
      name
      adminEmails
      intacctId
      customerName
      timezone
      notificationEmails
      legacyAcId
      usageType
      supportNotes
      defaultShowContentProgress
      defaultHoursOfOperation
      addons {
        id
        lid
        gidV3
      }
      edition {
        id
        gidV3
        lid
      }
      __typename
    }
  }
}
`;

const updateTenantMutation = `
mutation UpdateTenant($input: UpdateTenantInput!) {
  updateTenant(input: $input) {
    defaultContent {
      id 
    }
    domain { 
      id
      name
      legacyAcId
    }
    enabled
    id
    lid
    name
    adminEmails
    intacctId
    customerName
    timezone
    notificationEmails
    legacyAcId
    usageType
    supportNotes
    defaultShowContentProgress
    defaultHoursOfOperation
    edition {
      id
      gidV3
      lid
    }
    organization { 
      legacyAcId
      name
    }
    __typename
  }
  }
`;

const postTenantMutation = `
  mutation CreateTenant($input: CreateTenantInput!) {
    createTenant(input: $input) {
      defaultContent {
        id 
      }
      domain { 
        id
        name
        legacyAcId
      }
      enabled
      id
      lid
      name
      adminEmails
      intacctId
      customerName
      timezone
      notificationEmails
      legacyAcId
      usageType
      supportNotes
      defaultShowContentProgress
      defaultHoursOfOperation
      edition {
        id
        gidV3
        lid
      }
      organization { 
        legacyAcId
        name
      }
      __typename
    }
  }
`;

const getTenantDomainsQuery = `
query TenantV2OrgDomains($input: OrganizationKeyInput!) {
  organization(key: $input) {
    domains (after: null, first: 2000) {
      edges {
        node {
          id
          lid
          name
        }
      }
    }
  }
}
`;

export default class TenantsService {

  constructor(Restangular, SessionsService, StorageService) {
    'ngInject';
    this.Restangular = Restangular;
    this.SessionsService = SessionsService;
    this.StorageService = StorageService;
  }

  save(tenant) {
    let promise;
    if (tenant.key !== undefined || tenant.id !== undefined) {
      promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenant.id}`).customPUT(tenant);
    } else {
      promise = this.Restangular.service('tenants').post(tenant);
    }
    return promise;
  }

  saveOverlaySettings(tenantId, bottomLeft, bottomRight, topRight, topLeft) {
    let payload = {
      bottomLeft,
      bottomRight,
      topRight,
      topLeft,
    };
    return this.Restangular.oneUrl('overlay', `${process.env.__backendUrl__}/internal/v1/overlay/tenant/${tenantId}`).customPOST(payload);
  }

  createUnmanagedDevice(tenantId){
    return this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/devices/create_unmanaged_device`).post();
  }

  overlayApplyTenant(tenantId) {
    return this.Restangular.oneUrl('overlay', `${process.env.__backendUrl__}/internal/v1/overlay/tenant/${tenantId}/apply`).post();
  }

  getEditionsList(){
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/api/v1/content-manager/editions`).get();
    return promise;
  }

  getTenantEdition(tenantId){
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/api/v1/content-manager/editions/${tenantId}`).get();
    return promise;
  }

  searchAllTenantsByName(tenant_name, allDistributors) {
    let promise = this.Restangular.all('tenants').customGETLIST("", {
      tenantName: tenant_name, global: allDistributors
    });
    return promise;
  }

  fetchAllTenants() {
    let promise = this.Restangular.all('tenants').getList();
    return promise;
  }

  fetchAllTenantsPaginated(limit, page) {
    console.log(this.Restangular.configuration);
    // let promise = this.Restangular.oneUrl('tenants', `${this.Restangular.configuration.baseUrl}?limit=${limit}&page=${page}`).get();

    let promise = this.Restangular.oneUrl('tenants', `${this.Restangular.configuration.baseUrl}/tenants?limit=${limit}&page=${page}`).get();
    return promise;
  }

  checkTenantOu(tenantId) {
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/org_unit_accessible`).get();
    return promise;
  }

  checkTenantEnrollmentUser(tenantId) {
    let promise = this.Restangular.oneUrl('tenants', `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/enrollment_user_accessible`).get();
    return promise;
  }

  getTenantById(tenantId) {
    let url = `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}`;
    let promise = this.Restangular.oneUrl('tenants', url).get();
    return promise;
  }

  getBeaconDefaults(tenantId) {
    let url = `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/beacon`;
    let promise = this.Restangular.oneUrl('tenants', url).get();
    return promise;
  }

  delete(tenant) {
    if (tenant.key !== undefined) {
      let promise = this.Restangular.one('tenants', tenant.key).remove();
      return promise;
    }
  }

  getTenantV2URL = () => {
    const e = location.hostname === 'localhost' ? 'local' : process.env.__environment__;

    switch(e) {
      case 'int':
        return `https://api.skykit-int.app/tenants/v2/graphql`;
      case 'qa':
        return `https://api.skykit-qa.app/tenants/v2/graphql`;
      case 'stage':
        return `https://api.skykit-stage.app/tenants/v2/graphql`;
      case 'prod':
        return `https://api.skykit.app/tenants/v2/graphql`;
      case 'local':
        return `https://api.skykit-int.app/tenants/v2/graphql`;
      default:
        return `https://api.skykit-int.app/tenants/v2/graphql`;
    }
  }

  async getTenantV2Data(args, isPlatformAdmin) {
    return  await axios.post(
      this.getTenantV2URL(),
      { 
        query: isPlatformAdmin ? tenantV2Query : tenantV2QueryNonAdmin,
        variables: args 
      },
      {
      headers: {
        'Authorization': `Bearer ${this.SessionsService.getIdToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  /**
   * 
   * @param {Object} args 
   * @param {Array} args.addOnGids
   * @param {Array} args.adminEmails
   * @param {String} args.customerName
   * @param {Object} args.defaultHoursOfOperation
   * @param {Boolean} args.defaultShowContentProgress
   * @param {String} args.editionGid
   * @param {String} args.intacctId
   * @param {String} args.lid
   * @param {String} args.name
   * @param {String} args.notificationEmails
   * @param {String} args.supportNotes
   * @param {String} args.timezone
   * @param {String} args.usageType
   * @returns 
   */
  async updateTenantV2(args) {
    return  await axios.post(
      this.getTenantV2URL(),
      { 
        query: updateTenantMutation, 
        variables: {
          input: args
        } 
      },
      {
      headers: {
        'Authorization': `Bearer ${this.SessionsService.getIdToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  /**
   * 
   * @param {Object} args 
   * @param {Array} args.addOnGids
   * @param {Array} args.adminEmails
   * @param {String} args.customerName
   * @param {Object} args.defaultHoursOfOperation
   * @param {Boolean} args.defaultShowContentProgress
   * @param {String} args.domainGid
   * @param {String} args.editionGid
   * @param {String} args.intacctId
   * @param {String} args.lid
   * @param {String} args.name
   * @param {String} args.notificationEmails
   * @param {String} args.supportNotes
   * @param {String} args.timezone
   * @param {String} args.usageType
   * @returns 
   */
  async postTenantV2(args) {
    return  await axios.post(
      this.getTenantV2URL(),
      { 
        query: postTenantMutation, 
        variables: {
          input: args
        } 
      },
      {
      headers: {
        'Authorization': `Bearer ${this.SessionsService.getIdToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  async getTenantV2Domains(orgId) {
    return  await axios.post(
      this.getTenantV2URL(),
      { 
        query: getTenantDomainsQuery,
        variables: {
          input: {
            lid: orgId
          }
        }
      },
      {
      headers: {
        'Authorization': `Bearer ${this.SessionsService.getIdToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }
}

